module.exports = __webpack_public_path__ + "24d72b2608640344bf1448db61179b36.png";